var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "destination-option-card",
    class: [_vm.orientation, {
      selected: _vm.selected,
      'is-disabled': _vm.disabled
    }],
    on: {
      "click": _vm.onClick
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('v-icon', {
    staticClass: "card-icon",
    attrs: {
      "color": "#1F5FAC",
      "size": "24"
    }
  }, [_vm._v(_vm._s(_vm.icon))]), _c('div', {
    staticClass: "card-text"
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "card-desc"
  }, [_vm._v(_vm._s(_vm.description))])])], 1), _vm.$slots.action ? _c('div', {
    staticClass: "card-action"
  }, [_vm._t("action")], 2) : _vm._e(), _vm.selected ? _c('v-icon', {
    staticClass: "card-check",
    attrs: {
      "color": "#1F5FAC",
      "size": "20"
    }
  }, [_vm._v("mdi-check-circle")]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }